import { CompanyIcpType, } from '@hellodarwin/core/lib/features/entities/core-entities';
export const isNonProfitOrganization = (legalStructure) => {
    return (legalStructure === '2b9c3eaf-348b-4cf4-bf9e-cd4b8edb0c56' ||
        legalStructure === 'Non-Profit Organization');
};
export const determineCompanyIcpType = (selectedLocale, revenue, province, industries, legalStructure) => {
    const isCompanyNPO = isNonProfitOrganization(legalStructure || '');
    if (isCompanyNPO) {
        return CompanyIcpType.None;
    }
    if (revenue === '10m' ||
        revenue === '20m' ||
        revenue === '25m' ||
        revenue === '50m' ||
        revenue === '100m' ||
        revenue === '100m+') {
        return CompanyIcpType.Custom;
    }
    return CompanyIcpType.None;
};
